export default "<ion-app>\r\n  <app-sidemenu></app-sidemenu>\r\n</ion-app>";